import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKgGalleryPlaceholder = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 2,
		fill: "none",
		stroke: "currentColor",
		strokeLinejoin: "round",
		className: "nc-icon-wrapper",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M3 9h42v36H3zm7-6h28" }),
			/* @__PURE__ */ _jsx("path", { d: "m10 38 7-10 5 4 8-11 9 17H10z" }),
			/* @__PURE__ */ _jsx("circle", {
				cx: 17,
				cy: 19,
				r: 3
			})
		]
	})
});
export default SvgKgGalleryPlaceholder;
